import { useEffect, Component } from "react";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { MessageCircle } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import HomePage from "@/pages/Home";
import AboutPage from "@/pages/About";
import ProductsPage from "@/pages/Products";
import IndustryPage from "@/pages/Industry";
import TestimonialsPage from "@/pages/Testimonials";
import ContactPage from "@/pages/Contact";
import { SITE } from "@/data/content";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-brand-cream p-8 text-center">
          <div>
            <p className="font-display text-3xl text-brand-red">Something crumbled.</p>
            <p className="mt-3 text-brand-muted">{String(this.state.error)}</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <ErrorBoundary>
      <HashRouter>
        <ScrollManager />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/biscuit-industry" element={<IndustryPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
        <Footer />
        <a
          href={SITE.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="whatsapp-float"
          aria-label="Chat on WhatsApp"
          className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#1FA855] text-white shadow-2xl transition-transform duration-300 hover:scale-110"
        >
          <MessageCircle className="h-6 w-6" />
        </a>
      </HashRouter>
    </ErrorBoundary>
  );
}

export default App;
